import { render, staticRenderFns } from "./StickyUserDetails.vue?vue&type=template&id=32dc248a&"
import script from "./StickyUserDetails.vue?vue&type=script&lang=js&"
export * from "./StickyUserDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports